import React from 'react';
import { connect } from 'react-redux';
//import Modal from "components/common/modal";
export class ComparisonStats extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            peak: 0,
            average: 0,
            aboveHighMark: 0,
            belowHighMark: 0
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.nodes[0] && nextProps.nodes[1]) {
            var overview0 = nextProps.overviewMap[nextProps.nodes[0].id];
            var overview1 = nextProps.overviewMap[nextProps.nodes[1].id];
            if (overview0 && overview1 && !overview0.loading && !overview1.loading) {
                var data0 = overview0.data;
                var data1 = overview1.data;
                if (data0 && data1) {
                    var mHigh = 0, mLow = 0;
                    if (data0.marks && data1.marks) {
                        mHigh = Math.round((data0.marks[2] - data1.marks[2]) * 10000) / 100;
                        mLow = Math.round((data0.marks[0] - data1.marks[0]) * 10000) / 100;
                    }
                    this.setState({
                        peak: Math.round((data0.peak - data1.peak) * 10000) / 100,
                        average: Math.round((data0.average - data1.average) * 10000) / 100,
                        aboveHighMark: mHigh,
                        belowHighMark: mLow
                    });
                }
            }
        }
    }

    render() {
        return (
            <div className="widget-card__comparison-stats box--shadow bg--white ">
                {/*   <div className="clearfix">
                    <div className="col-xs-12">
                        <Modal
                            disableCloseButton={true}
                            ref={(elem) => { this.openInfoModal = elem }}
                            clickButton={() => { this.openInfoModal.close(); }}
                            header="Info Modal"
                            buttonText="Got it"
                            buttonClass="btn-success"
                            entry={
                                <div style={{ marginRight: "-5px" }} onClick={() => { this.openInfoModal.open() }} className="pull-right">
                                    <img className="card-info cursor--pointer" src="src/assets/icons/info.svg" alt="info-icon" />
                                </div>
                            }
                        >
                            <p>Comparison stats Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
                        </Modal>
                    </div>
                        </div>*/}
                <h2 className="widget-card__comparison-stats__title">Comparison</h2>
                <div className="widget-card__comparison-stats__body">
                    <p>Peak: <span> {this.state.peak > 0 ? `+${this.state.peak}` : this.state.peak}%</span></p>
                    <p>Average: <span>  {this.state.average > 0 ? `+${this.state.average}` : this.state.average}%  </span></p>
                    <p>Above High Mark: <span> {this.state.aboveHighMark > 0 ? `+${this.state.aboveHighMark}` : this.state.aboveHighMark}%  </span></p>
                    <p>Below Low Mark: <span> {this.state.belowHighMark > 0 ? `+${this.state.belowHighMark}` : this.state.belowHighMark}%  </span></p>
                </div>

            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        nodes: state.comparisonReducer.nodes,
        overviewMap: state.statsReducer.overviewMap
    };
}

export default connect(mapStateToProps, null)(ComparisonStats);



// WEBPACK FOOTER //
// ./src/components/pages/comparison/comparisoncard/comparisonstats.jsx